<img
  style="display:none"
  alt="tilray"
  src="{`https://ad.ipredictive.com/d/track/event?upid=103246&url=${window.location.href || ''}&cache_buster=[${new Date().getTime()}]&ps=2`}"
  width="1"
  height="1"
/>
